import { axiosGet } from '@/utils/axios';

import { SYN_API_URLS } from '@/constants/api';
import {
  FetchMarketPairInfoInput,
  FetchMarketPairInfoResponse,
  FetchMarketPairListResponse,
  IMarketPair,
} from './types';

export const fetchMarketPairInfo = async ({
  chainId,
  address,
  expiry,
}: FetchMarketPairInfoInput): Promise<FetchMarketPairInfoResponse> => {
  const res = await axiosGet({
    url: SYN_API_URLS.MARKET.PAIR_INFO,
    config: { params: { chainId, instrument: address, expiry } },
  });
  if (res?.data?.data) {
    const p = res?.data?.data;
    return transformMarketInfo(p, chainId);
  }
  return null;
};

export const fetchMarketPairList = async ({ chainId }: { chainId: number }): Promise<FetchMarketPairListResponse> => {
  const res = await axiosGet({ url: SYN_API_URLS.MARKET.PAIR_LIST, config: { params: { chainId } } });
  if (res?.data?.data) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return res?.data?.data.map((p: any) => transformMarketInfo(p, chainId));
  }
  return null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformMarketInfo(p: any, chainId: number): IMarketPair {
  return {
    ...p,
    symbol: p.fullSymbol,
    displaySymbol: p.symbol,
    chainId: chainId,
  };
}
